import React from "react";
import ReactDOM from "react-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";

import AppRouter from "./components/AppRouter.js";
import reducers from "./reducers";
import "./css/index.scss";

const store = createStore(reducers);

ReactDOM.render(
	<Provider store={store}>
		<AppRouter />
	</Provider>,
	document.getElementById("root")
);
